import { css } from '@emotion/react';

const styles = css`
  html,
  body {
    height: 100%;

    .wrapper,
    .page {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  html.is-locked, html.is-locked body {
      overflow: hidden;
    }
  }

  #wrap {
    min-height: 100%;
  }

  button,
  input,
  textarea {
    &:focus,
    &:active {
      outline: none !important;
      border-color: #cfcfcf !important;
      box-shadow: none !important;
    }
  }

  a {
    &:hover,
    &:active,
    &:focus,
    &:visited {
      text-decoration: none;
      cursor: pointer;
    }
  }
`;

export default styles;
